//CREATE_USER_SERVICE_REQUEST
export const CREATE_USER_SERVICE_REQUEST_REQUEST =
  "CREATE_USER_SERVICE_REQUEST_REQUEST";
export const CREATE_USER_SERVICE_REQUEST_SUCCESS =
  "CREATE_USER_SERVICE_REQUEST_SUCCESS";
export const CREATE_USER_SERVICE_REQUEST_FAIL =
  "CREATE_USER_SERVICE_REQUEST_FAIL";

//DELETE_USER_SERVICE_REQUEST
export const DELETE_USER_SERVICE_REQUEST_REQUEST =
  "DELETE_USER_SERVICE_REQUEST_REQUEST";
export const DELETE_USER_SERVICE_REQUEST_SUCCESS =
  "DELETE_USER_SERVICE_REQUEST_SUCCESS";
export const DELETE_USER_SERVICE_REQUEST_FAIL =
  "DELETE_USER_SERVICE_REQUEST_FAIL";

//GET_USER_SERVICE_REQUEST
export const GET_USER_SERVICE_REQUEST_REQUEST =
  "GET_USER_SERVICE_REQUEST_REQUEST";
export const GET_USER_SERVICE_REQUEST_SUCCESS =
  "GET_USER_SERVICE_REQUEST_SUCCESS";
export const GET_USER_SERVICE_REQUEST_FAIL = "GET_USER_SERVICE_REQUEST_FAIL";
